<template>
  <div class="text-center">
    <img :src="path" class="img-fluid" v-if="component.file" />
  </div>
</template>

<script>
export default {
  props: ['component'],
  data() {
    return {
      path: `https://djceg34j53tq.cloudfront.net/${this.component.file}`,
    }
  },
}
</script>
